<template>
    <main class="page__content">
        <!-- project detail start -->
        <div class="project" v-if="project">
            <div class="project-content-slot">
                <div class="project-content">
                    <div class="project-content__inner">
                        <div class="project__header">
                            <h1>
                                {{ project.titel }}
                            </h1>
                        </div>
                        <div class="project__image">
                            <div class="project__image-inner">
                                <img :src="project.bild" alt="project-image">
                            </div>
                        </div>
                        <div class="project__actions">

                            <!-- spend box start -->
                            <spend-box
                                :project-id="project.id"
                                :project-closed="isClosed"
                                @scroll-to="scrollTo"
                            />
                            <!-- spend box end -->

                            <div class="project__state" v-if="!isClosed">
                                <div class="project__budget-info-slot">
                                    <span class="project__state-hearts">
                                        {{ project.hearts_count }}
                                    </span>
                                    {{ project.hearts_count > 1 || project.hearts_count === 0 ? 'Herzen' : 'Herz' }} gesammelt
                                </div>
                                <div class="project__budget-info-slot">
                                    <span class="project__state-euro">
                                        {{ budgetInEuro }}
                                    </span>
                                    € erreicht
                                </div>
                                <div class="project__budget-info-bar">
                                    <span class="project__budget-info-bar-bg" :style="budgetInfoBarStyle"></span>
                                    <span class="project__budget-info-bar-label">
                                        <span class="project__state-percent">
                                            {{ budgetPercent }}%
                                        </span>
                                        von {{ budgetTargetInEuro }} € erreicht
                                    </span>
                                </div>
                            </div>

                            <div class="project__share">
                                <h3>
                                    Dieses Projekt teilen
                                </h3>
                                <div class="project__share-inner">
                                    <a :href="shareLinks.wa" target="_blank" title="WhatsApp teilen">
                                        <span class="mdi mdi-whatsapp" aria-hidden="true"></span>
                                    </a>
                                    <a :href="shareLinks.fb" target="_blank" title="Facebook teilen">
                                        <span class="mdi mdi-facebook" aria-hidden="true"></span>
                                    </a>
                                    <a :href="shareLinks.li" target="_blank" title="LinkedIn teilen">
                                        <span class="mdi mdi-linkedin" aria-hidden="true"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="project-content-slot">
                <div class="project-content">
                    <div class="project-content__inner">
                        <div class="project__description">
                            <h2>Über dieses Projekt</h2>
                            <p v-html="projectText"></p>

                            <!--
                            <div class="project__note project__note--custom">
                                <h3>Von Null auf 100 - Starthilfe für grüne Projekte</h3>
                                <div class="project__note-cols">
                                    <p>
                                        2024 steht bei den Stadtwerken Velbert unter einem grünen Stern: Für eine grüne Zukunft in Velbert fördern wir vom 08.03. bis zum 31.12.2024 nachhaltige Projekte mit einer Starthilfe von 100,00 Euro. Ob Projekte einstellen oder Herzen-Spender werden, es lohnt sich!
                                        <router-link
                                            :to="{name: 'ParticipationTerms', hash: '#aktion'}"
                                        >
                                            Die erweiterten Teilnahmebedingungen finden Sie hier.
                                        </router-link>
                                    </p>
                                    <img src="@/assets/img/leaf.png" alt="Grünes Blatt">
                                </div>
                            </div>
                            -->

                            <div id="note" class="project__note">
                                <h3>Sie haben noch keinen Herz-Code und möchten ein Projekt unterstützen?</h3>
                                <p>
                                    Kein Problem! <router-link :to="{name: 'RequestCode'}">Klicken Sie hier und fordern Sie Ihren Herz-Code an.</router-link>
                                </p>
                                <p>
                                    Schon gewusst? Sie können alle 30 Tage einen Spendencode anfordern. Also - bald wiederkommen, Spendencode anfordern und Gutes für Velbert tun.
                                </p>
                            </div>

                            <router-link
                                class="btn btn--blue"
                                :to="{name: 'PageStart', hash: '#projects-overview'}"
                            >
                                <span class="mdi mdi-chevron-left"></span> zurück zur Übersicht
                            </router-link>
                        </div>
                        <div class="project__info">
                            <div class="project__logo" v-if="project.logo">
                                <img :src="project.logo" alt="">
                            </div>
                            <div class="project__info-copy">
                                <p>
                                    <strong>
                                        <template v-if="project.projekttraeger_organisation">
                                            {{ project.projekttraeger_organisation }} <br>
                                        </template>
                                        <template v-else>
                                            {{ project.projekttraeger_vorname }}
                                            {{ project.projekttraeger_nachname }}
                                        </template>
                                        {{ projectLocation.street }} {{ projectLocation.number }}<br>
                                        {{ projectLocation.zipcode }} {{ projectLocation.city }}<br><br>
                                    </strong>
                                    <template v-if="project.projekttraeger_telefonnummer">
                                        Tel.: {{ project.projekttraeger_telefonnummer }}<br>
                                    </template>
                                    <template v-if="project.projekttraeger_email">
                                        <a :href="'mailto:' + project.projekttraeger_email">
                                            {{ project.projekttraeger_email}}
                                        </a>
                                    </template>
                                </p>
                                <p v-if="project.projekttraeger_internetadresse">
                                    <a :href="project.projekttraeger_internetadresse" target="_blank">
                                        {{ getUrlHost(project.projekttraeger_internetadresse) }}
                                    </a>
                                </p>
                                <p v-if="project.bankverbindung_iban && project.bankverbindung_bic">
                                    Gerne können Sie auch außerhalb unserer
                                    Aktion etwas spenden: <br><br>

                                    IBAN {{ project.bankverbindung_iban }}<br>
                                    BIC {{ project.bankverbindung_bic }} <br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- project detail end -->
    </main>
</template>

<script>
import { mapState } from 'vuex'
import VueScrollTo from 'vue-scrollto'

import ShareLinks from '@/mixins/ShareLinks'
import ProjectBudget from '@/mixins/ProjectBudget'
import ProjectLocation from '@/mixins/ProjectLocation'

import SpendBox from '@/components/SpendBox'

export default {
    name: 'PageDetail',

    mixins: [
        ProjectBudget,
        ProjectLocation,
        ShareLinks
    ],

    components: {
        SpendBox
    },

    computed: {
        ...mapState([
            'projects'
        ]),

        project () {
            return this.projects.find(project => {
                return project.id === parseInt(this.$route.params.id)
            })
        },

        isClosed () {
            return this.project.archiviert || !this.project.hearts_left
        },

        projectText () {
            if (!this.project) {
                return ''
            }
            return this.project.ausfuehrliche_beschreibung.replace(/\n/g, '<br>')
        }
    },

    methods: {
        getUrlHost (url) {
            // eslint-disable-next-line
            const urlParts = url.match(/(.+:\/\/)?([^\/]+)(\/.*)*/i)
            return urlParts && urlParts[2] ? urlParts[2] : url
        },

        scrollTo (selector) {
            const options = {
                container: 'body',
                easing: 'ease-out',
                offset: -100,
                force: true
            }

            this.$nextTick().then(() => {
                VueScrollTo.scrollTo(selector, 500, options)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PageDetail.vue